import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import clsx from "clsx";

export default function CollapsibleCard({ title, content, isActive, onClick }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      onClick={onClick}
      className={clsx(
        "relative cursor-pointer overflow-hidden rounded-xl p-4",
        "border transition-colors duration-200",
        "text-white",

        // 🔹 Base
        "border-white/10 bg-black/40",

        // Hover
        !isActive && "hover:border-white/20 hover:bg-black/50",

        // 🔥 Activo
        isActive && "border-white/20 bg-black/60",
      )}
    >
      {/* Indicador de selección */}
      {isActive && (
        <div className="absolute left-0 top-0 h-full w-1 rounded-l-xl bg-yellow-400" />
      )}

      <div
        className="flex select-none items-center justify-between"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen((v) => !v);
        }}
      >
        <h3
          className={clsx(
            "text-lg font-medium transition-colors",
            isActive ? "text-yellow-300" : "text-white",
          )}
        >
          {title}
        </h3>

        <span
          className={clsx(
            "text-sm transition-colors",
            isActive ? "text-yellow-300" : "text-white/60",
          )}
        >
          {isOpen ? "−" : "+"}
        </span>
      </div>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            className="mt-2 overflow-hidden text-sm text-white/80"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
          >
            <div className="py-2">{content}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
